import { useNavigate } from 'react-router-dom';
import T from '../i18n/content.js';
import { useLang, useT } from '../i18n/LangContext.jsx';

const FIRM_LINK_TARGETS = ['/firm', '/founder', '/insights'];
// F.bottom order: [Privacy, Notices]
const BOTTOM_TARGETS = ['/privacy', '/notices'];
// Privacy (0) and Notices (1) are hidden pending legal sign-off — remove these
// indices from the set (and restore the routes in App.jsx) to show them again.
const HIDDEN_BOTTOM = new Set([0, 1]);

export default function Footer() {
  const { lang } = useLang();
  const t = useT();
  const navigate = useNavigate();
  const F = T.footer;

  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="footer__mark">
          {lang === 'en' ? (
            <>DEXON</>
          ) : (
            <span className="cn">德 铉</span>
          )}
        </div>

        <div className="footer__col">
          <h4>{t(F.headings.firm)}</h4>
          <ul>
            {F.firmLinks.map((l, i) => (
              <li key={i}>
                <button onClick={() => navigate(FIRM_LINK_TARGETS[i])}>{t(l)}</button>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer__col">
          <h4>{t(F.headings.practice)}</h4>
          <ul>
            {T.practices.map(p => (
              <li key={p.num}>
                <button onClick={() => navigate(`/practice#practice-${p.num}`)}>{t(p.name)}</button>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer__col">
          <h4>{t(F.headings.contact)}</h4>
          <ul>
            <li>{t(F.byIntro)}</li>
            {/* email temporarily hidden on the frontend */}
          </ul>
        </div>
      </div>

      <div className="footer__bottom">
        <span>{t(F.legal)}</span>
        <div className="right">
          {F.bottom.map((l, i) => {
            if (HIDDEN_BOTTOM.has(i)) return null;
            return BOTTOM_TARGETS[i]
              ? <button key={i} onClick={() => navigate(BOTTOM_TARGETS[i])}>{t(l)}</button>
              : <span key={i}>{t(l)}</span>;
          })}
        </div>
      </div>
    </footer>
  );
}
